import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { Avatar as BaseAvatar, useTheme } from "native-base";
import resolveImage from "../../util/resolveImage";
import placeholder from "./default.png";
const Avatar = ({ source, size = "md", initials, isCircle = true, status, }) => {
    const { radii } = useTheme();
    const imageSource = useMemo(() => (source ? source : initials ? undefined : placeholder), [source, initials]);
    return (_jsxs(BaseAvatar, Object.assign({ source: resolveImage(imageSource), size: size, style: { borderRadius: isCircle ? radii.full : radii[size] }, _image: {
            borderWidth: "1",
            borderColor: "gray.100",
            borderRadius: isCircle ? radii.full : radii[size],
        } }, { children: [initials, status && (_jsx(BaseAvatar.Badge, { bg: `${status === "active" ? "green" : "rose"}.500` }))] })));
};
export default Avatar;
